import { Component, Element, h, Prop } from '@stencil/core'

import Helpers from '../../../utils/helpers'
import { CssClassMap } from '../../../utils/interfaces'

/**
 * O subcomponente `br-footer-social` representa os ícones de redes sociais no rodapé do site, de acordo com a documentação de design do GovBR.
 * Ele deve ser utilizado como filho direto do componente [`br-footer`](/docs/components/footer).
 */
@Component({
  tag: 'br-footer-social',
  styleUrl: 'footer-social.scss',
  shadow: true,
})
export class FooterSocial {
  /**
   * Referência ao elemento host do componente.
   * Utilize esta propriedade para acessar e manipular o elemento do DOM associado ao componente.
   */
  @Element() el: HTMLBrFooterSocialElement

  /**
   * Identificador único.
   * Caso não seja fornecido, um ID gerado automaticamente será usado.
   */
  @Prop({ reflect: true }) readonly customId: string = Helpers.generateUniqueId()

  /**
   * Ícone da rede social
   * */
  @Prop({ reflect: true }) readonly icon: string

  /**
   * Descrição do ícone da rede social
   * */
  @Prop({ reflect: true }) readonly description: string

  /**
   * URL da rede social
   */
  @Prop({ reflect: true }) readonly href: string = null

  /**
   * Monta o objeto com as classes CSS do componente.
   * @returns Objeto com as classes CSS do componente.
   */
  private getCssClassMap(): CssClassMap {
    return {
      'br-footer-social': true,
      'spacing-icons': true,
    }
  }

  /**
   * Renderiza o componente.
   * @returns JSX do componente.
   */
  render() {
    return (
      <br-button
        role="link"
        class={this.getCssClassMap()}
        id={this.customId}
        emphasis="tertiary"
        shape="circle"
        aria-label={this.description}
      >
        <a href={this.href} tabindex="-1">
          <br-icon icon-name={`fa-brands:${this.icon}`} aria-hidden="true"></br-icon>
        </a>
      </br-button>
    )
  }
}
